import { useEffect, useMemo, useState } from "react";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import dayjs from "dayjs";
import { useParams } from "react-router";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { createRow, MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Box, IconButton, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete"
import { Button, COLORS, Icon, ICONS, Modal } from "abs-ui-components";
import { API_ROUTES } from "../../ApiRoutes/ApiRoutes";

const FuelConsCollectionPlanRevisions = ({ fuelConsCollectionPlanRevisions, refetchMonitoringData, vesselMstId }) => {

    const [activeAction, setactiveAction] = useState(-1);
    const [validationErrors, setValidationErrors] = useState({});
    const [fuelConsData, setFuelConsData] = useState([]);
    const RowActions = {
        Edit: 0,
        Add: 1,
    };
    const [confirmDelete, setConfirmDelete] = useState(false);
	const [deletingRowIndex, setDeletingRowIndex] = useState();
	const handleDeleteBtnClick = (rowIndex) => {
		setConfirmDelete(true);
		setDeletingRowIndex(rowIndex);
	};
    useEffect(() => {
        if (Array.isArray(fuelConsCollectionPlanRevisions)) {
            setFuelConsData(fuelConsCollectionPlanRevisions);
        } else {
            setFuelConsData([]);
        }
    }, [fuelConsCollectionPlanRevisions]);

    useEffect(() => {
        if (Array.isArray(fuelConsCollectionPlanRevisions)) {
            const transformedData = fuelConsCollectionPlanRevisions?.map((item) => {
                return {
                    dateOfRevision: item.dateOfRevision || "",
                    revisedProvision: item.revisedProvision || ""
                };
            });

            setFuelConsData((transformedData));
        }
    }, [fuelConsCollectionPlanRevisions]);

    const resetActiveRow = () => {
        setactiveAction(-1);
        setValidationErrors({});
    };
    const handleCreateFuelConsCollectionPlan = async ({ values, table }) => {
        const newRow = {
            index: 0,
            dateOfRevision: values?.dateOfRevision,
            revisedProvision: values?.revisedProvision,
        };
        const payload = fuelConsData?.map((item) => ({
            ...item,
            index: 0
        }));
        const finalPayload = ([...payload, newRow]);
        try {
            const fuelConsCollectionData = await callApi({
                method: "POST",
                url: API_ROUTES.FuelConsCollectionPlan(vesselMstId),
                data: finalPayload,
            });
            if (fuelConsCollectionData?.isSuccess) {
                emitToasterMsg("success", "Table  Record of revision of Fuel Oil Consumption Data-Collection Plan", "has been added successfully");
                table.setCreatingRow(null);
                setFuelConsData(finalPayload);
                setactiveAction(-1);
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }

            }
            else {
                emitToasterMsg("error", "Table  Record of revision of Fuel Oil Consumption Data-Collection Plan", fuelConsCollectionData?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table  Record of revision of Fuel Oil Consumption Data-Collection Plan", error.errorMessage);
        }
    };

    const handleUpdateFuelConsCollectionPlan = async ({ values, table, row }) => {

        const updated = fuelConsData.map((item, index) => {
            if (index === row.index) {
                return {
                    ...item,
                    dateOfRevision: values?.dateOfRevision,
                    revisedProvision: values?.revisedProvision,
                };
            }
            return item;
        });
        const finalPayload = (updated).map(i => ({ ...i, index: 0 }));

        try {
            const fuelConsCollectionData = await callApi({
                method: "POST",
                url: API_ROUTES.FuelConsCollectionPlan(vesselMstId),
                data: finalPayload,
            });
            if (fuelConsCollectionData?.isSuccess) {
                emitToasterMsg("success", "Table  Record of revision of Fuel Oil Consumption Data-Collection Plan", "has been updated successfully");
                table.setEditingRow(null);
                setactiveAction(-1);
                setFuelConsData(finalPayload);
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table  Record of revision of Fuel Oil Consumption Data-Collection Plan", fuelConsCollectionData?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table  Record of revision of Fuel Oil Consumption Data-Collection Plan", error.errorMessage);
        }
    };

    const handleDeleteFuelConsCollectionPlan = async (rowIndex) => {
        const updatedData = fuelConsData.filter((_, index) => index !== rowIndex);
        const finalPayload = updatedData?.map((item) => ({
            ...item,
            index: 0
        }));
        try {
            const fuelConsCollectionData = await callApi({
                method: "POST",
                url: API_ROUTES.FuelConsCollectionPlan(vesselMstId),
                data: finalPayload,
            });
            if (fuelConsCollectionData?.isSuccess) {
                emitToasterMsg("success", "Table  Record of revision of Fuel Oil Consumption Data-Collection Plan", "has been deleted successfully");
                setactiveAction(-1);
                setConfirmDelete(false);
                setFuelConsData(finalPayload);
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table  Record of revision of Fuel Oil Consumption Data-Collection Plan", fuelConsCollectionData?.errorMessage);
                setConfirmDelete(false);
            }
        } catch (error) {
            emitToasterMsg("error", "Table  Record of revision of Fuel Oil Consumption Data-Collection Plan", error.errorMessage);
        }
    };

    const handleFuelConsCollectopPlan = (table, row, action) => {
        if (activeAction !== -1) return;

        if (action === RowActions.Add) {
            const defaultRow = createRow(table, {
                dateOfRevision: dayjs().toISOString(),
                revisedProvision: ''
            });
            table.setCreatingRow(defaultRow);
            setactiveAction(action);
            return;
        }
        if (action === RowActions.Edit) {
            table.setEditingRow(row);
            setactiveAction(action);
        }
    };
    const updateData = (rowIndex, columnId, value) => {
        setFuelConsData(prev =>
            prev.map((row, index) => {
                if (index === rowIndex) {
                    return {
                        ...row,
                        [columnId]: value,
                    };
                }
                return row;
            })
        );
    };

    const columns = useMemo(
        () => [
            {
                accessorKey: "dateOfRevision",
                header: "Date of revision",
                muiTableHeadCellProps: {
                    sx: {
                        borderBottom: 'none',
                        borderRight: '1px solid lightgray',
                        verticalAlign: "middle"
                    },
                },
                Cell: ({ cell }) =>
                    cell.getValue()
                        ? dayjs(cell.getValue()).format('DD-MMM-YYYY')
                        : '',
                Edit: ({ cell, column, row, table }) => (
                    <DatePicker
                        value={cell.getValue() ? dayjs(cell.getValue()) : null}
                        onChange={(newValue) => {
                            const isoValue = newValue?.toISOString?.();
                            if (table.getState().creatingRow) {
                                // Use _valuesCache for createRow flow
                                row._valuesCache[column.id] = isoValue;
                            } else {
                                // Use updateData for edit mode
                                table.options.meta?.updateData?.(row.index, column.id, isoValue);
                            }
                        }}
                        format="DD-MMM-YYYY"
                        slotProps={{
                            textField: {
                                sx: {
                                    "& .MuiInputBase-root": { height: 36 },
                                    "& input": {
                                        padding: "8px 10px",
                                        fontSize: "14px",
                                    },
                                },
                            },
                        }}
                    />
                )
            },
            {
                accessorKey: "revisedProvision",
                header: "Revised provision",
                muiTableHeadCellProps: {
                    sx: {
                        borderBottom: 'none',
                        borderRight: '1px solid lightgray',
                        verticalAlign: "middle"
                    },
                },
                Cell: ({ cell }) => cell.getValue() ?? "",
                muiEditTextFieldProps: ({ cell, column, row, table }) => ({
                    inputProps: { maxLength: 255 },
                    value: cell.getValue() ?? "",
                    onChange: (e) => {
                        const value = e.target.value;
                        if (table.getState().creatingRow) {
                            row._valuesCache[column.id] = value;
                        } else {
                            table.options.meta?.updateData?.(row.index, column.id, value);
                        }
                    },
                }),


            }
        ], [

    ]
    )

    const table = useMaterialReactTable({
        columns,
        data: fuelConsData || [],
        meta: {
            updateData,
        },

        enableStickyHeader: true,
        enableSorting: false,
        enableRowSelection: false,
        enableColumnPinning: false,
        enableTopToolbar: true,
        enableBottomToolbar: false,
        enableColumnActions: false,
        createDisplayMode: "row",
        editDisplayMode: "row",
        enableEditing: true,
        enablePagination: false,
        muiTableHeadCellProps: {
            sx: {
                color: "rgb(255 255 255)",
                backgroundColor: "#042a4c",
                position: "sticky",
                borderRight: "1px solid lightgray",
                "&:last-child": {
                    borderRight: "none",
                },
            },
        },
        muiTablePaperProps: {
            sx: {
                boxShadow: "0 0 8px 2px rgba(0, 0, 0, 0.1)",
            },
        },
        muiTableContainerProps: {
            sx: {
                maxHeight: "520px",
            },
        },
        displayColumnDefOptions: {
            'mrt-row-actions': {
                muiTableHeadCellProps: {
                    sx: {
                        borderBottom: 'none',
                        borderRight: '1px solid lightgray',
                    },
                },
            },
        },
        muiTableBodyCellProps: ({ row, cell }) => {
            return {
                sx: {
                    borderRight: "1px solid lightgray",
                    "&:last-child": {
                        borderRight: "none",
                    },
                    color: "",
                },
            };
        },
        muiTableBodyRowProps: ({ row }) => ({
            sx: {
                "&:not(:last-of-type)": {
                    borderBottom: "1px solid lightgray",
                },
                verticalAlign: "top",
            },
        }),
        muiTableHeadRowProps: {
            sx: {
                borderBottom: "2px solid lightgray",
            },
        },
        columnOrder: [
            "dateOfRevision",
            "revisedProvision",
        ],
        onCreatingRowSave: handleCreateFuelConsCollectionPlan,
        onEditingRowCancel: resetActiveRow,
        onCreatingRowCancel: resetActiveRow,
        onEditingRowSave: handleUpdateFuelConsCollectionPlan,
        renderToolbarInternalActions: ({ table }) => <></>,
        renderRowActions: ({ row, table }) => {
            return (
                <Box sx={{ display: "flex", gap: "2rem" }}>
                    <Box>
                        <Tooltip title="Edit" sx>
                            <IconButton
                                style={{ padding: "0px" }}
                                onClick={() =>
                                    handleFuelConsCollectopPlan(
                                        table,
                                        row,
                                        RowActions.Edit
                                    )
                                }
                            >
                                <EditIcon />
                            </IconButton>
                        </Tooltip>
                    </Box>
                    <Box>
                        <Tooltip title="Delete">
                            <IconButton
                                style={{ padding: "0px" }}
                                color="error"
                                onClick={() => handleDeleteBtnClick(row?.index, true)}
                            >
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
            );
        },
        renderTopToolbarCustomActions: ({ table }) => (
            <div className="mt-1">
                <Button
                    startIcon={<Icon icon={ICONS.ADD} />}
                    onClick={() => {
                        handleFuelConsCollectopPlan(table, null, RowActions.Add);
                    }}
                    disabled={!!table.getState().creatingRow}
                >
                    Add record
                </Button>
            </div>
        ),
    });

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div className="fuel-registry-b3 mt-1">
                <MaterialReactTable table={table} />
            </div>
            <div className="confirmation-modal-container">
				<Modal
					isOpen={confirmDelete}
					modalHeader
					padding={"70px"}
					headerHeight={"50px"}
					showFooter
					onCloseClickListener={() => {
						setConfirmDelete(false);
					}}
					footer={
						<div className="d-flex justify-content-end fixed-action-btns p-4">
							<Button
								className="modal-delete-btn"
								onClick={() => {
									handleDeleteFuelConsCollectionPlan(deletingRowIndex);
								}}
								primaryColor={COLORS.RED.DARK}
								primaryBackgroundColor={COLORS.RED.LIGHT}
							>
								Delete
							</Button>

							<Button
								className="modal-cancel-btn"
								onClick={() => {
									setConfirmDelete(false);
								}}
							>
								Cancel
							</Button>
						</div>
					}
				>
					<div>Are you sure you want to delete this fuel type?</div>
				</Modal>
			</div>
        </LocalizationProvider>);


}
export default FuelConsCollectionPlanRevisions

